<div class="task-detail-container">
  <div class="task-ref">Task {{ task.position }}</div>
  <div class="{{ task.isCancelled ? 'cancelled' : '' }}">
    <vehicle-reg>{{ task.task.vehicle.registrationNumber }}</vehicle-reg>
  </div>
  <div *ngIf="!task.isCancelled" style="display: flex; flex-direction: column; gap: 12px">
    <span class="tag bolt" style="width: 90px" *ngIf="task.task.vehicle.isElectric"
      ><img src="assets/images/icons/svg/ev-icon.svg" alt="icon" class="icon" /> Electric</span
    >
    <span class="tag bolt" style="width: 90px" *ngIf="!task.task.vehicle.isElectric">{{
      task.task.vehicle.fuelType ?? 'Unknown'
    }}</span>
    <span class="tag grabbed" style="width: 90px" *ngIf="task.grabbed"
      ><i class="fa fa-link" aria-hidden="true"></i> My Task</span
    >
    <p class="link-style hover:text-blue-900 cursor-pointer" style="font-size: 15px; margin: 0px">
      <!--<a target="_blank" routerLink="/app/jobscreen/{{ task.task.jobId }}">
        Job Details <i class="fa fa-external-link ml-1"></i>
      </a>-->
    </p>
    <p
      class="link-style hover:text-blue-900 cursor-pointer"
      style="font-size: 15px; margin: 0px"
      (click)="viewDirectionLink.emit()"
    >
      Google Directions <i class="fa fa-external-link ml-1"></i>
    </p>

    <button class="task-expander-toggle" (click)="expanderToggle.emit()" type="button">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      Additional Information
      <i class="fa fa-chevron-{{ expanded ? 'up' : 'down' }}" aria-hidden="true"></i>
    </button>
  </div>
  <div *ngIf="task.isCancelled">
    <span class="tag" style="width: 90px; background-color: #f8d6d6" *ngIf="task.isCancelled"
      ><i class="fa fa-times" style="color: #dc3535" aria-hidden="true"></i> Cancelled</span
    >
  </div>
</div>
